import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { normalizeContactPhone } from "@/modules/common/utils/customer-contact";
import CallIcon from "@/assets/icons/lead-page/call-icon";
import CallPopoverButton from "@/modules/common/components/call-popover-button";
import useLeadContactMethods from "../../hooks/lead-info/lead-contact-methods.hook";

const ContactPhoneIcon = ({ phoneNumber }: { phoneNumber?: string }) => {
  const { isLoading } = useLeadContactMethods();
  const theme = useTheme();
  const phone = normalizeContactPhone(phoneNumber);

  return (
    <Tooltip title={phone ? "Call" : "Phone number unavailable"}>
      <Box component="span" sx={{ display: "inline-flex" }}>
        <CallPopoverButton phoneNumber={phoneNumber}>
          <IconButton
            data-testid="lead-call-button"
            aria-label={phone ? "Call" : "Phone number unavailable"}
            disabled={isLoading || !phone}
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              backgroundColor: theme.nawy.colors.semantic.layer.accent,
              padding: "8px",
              "&:hover": {
                backgroundColor: theme.nawy.colors.primitives.navy[700],
              },
              "&.Mui-disabled": {
                backgroundColor: theme.nawy.colors.semantic.layer.accent,
                opacity: 0.5,
              },
            }}
          >
            <CallIcon fill="white" />
          </IconButton>
        </CallPopoverButton>
      </Box>
    </Tooltip>
  );
};

export default ContactPhoneIcon;
